export default (
    lRef,
    rRef
) => ((lRef[0] === '/' ? '' : '/') + lRef) === ((rRef[0] === '/' ? '' : '/') + rRef);